module.exports = __webpack_public_path__ + "assets/img/6_492_big.d7cc9da1.jpg";